import {useLazyQuery} from '@apollo/client';
import {
  GetModelPortfolios,
  GetModelPortfoliosVariables,
} from '../../schema-types/GetModelPortfolios';
import {LIST_MODEL_PORTFOLIOS} from './mandatesPageQueries';
import useAccountId from '../../hooks/useAccountId';
import {useAccountContext} from '../../contexts/AccountContext';
import {BusinessUnitEnum} from '../../schema-types/globalTypes';
import validateUUID from '../../utils/validateUUID';

export default function useModelPortfolios() {
  const {accountType} = useAccountContext();
  const {accountId} = useAccountId();
  const [listModelPortfolios] = useLazyQuery<
    GetModelPortfolios,
    GetModelPortfoliosVariables
  >(LIST_MODEL_PORTFOLIOS);

  const getModelPortfolios = async ({
    productProviderId,
    productNameId,
    potId,
    hasBondParent,
  }: {
    productProviderId?: string;
    productNameId?: string;
    showPanel?: boolean;
    potId?: string;
    hasBondParent?: boolean;
  }) => {
    const result = await listModelPortfolios({
      variables: {
        showPanel: true, //  always pull the panel mandates in
        productId: productNameId,
        providerId: productProviderId,
        accountId,
        isSppDa: accountType === BusinessUnitEnum.DA,
        potId: validateUUID(potId),
        parent: hasBondParent ? 'bond' : undefined,
      },
    });
    return result.data?.modelPortfolios || [];
  };

  return {
    getModelPortfolios,
  };
}
